module.exports = {"id":"186598","name":"Kyle Naughton","rating":"74","photo":"./data/images/photos/1/186598.png","club":{"name":"Swansea City","logo":"./data/images/clubs/SwanseaCity.png"},"positions":["DD","DLD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KyleNaughton0.json
// module id = 2414
// module chunks = 0